import {
  Component,
  Injector,
  OnInit,
  SkipSelf,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';

import { ModalService } from './modal.service';

@Component({
  selector: 'fl-modal',
  template: `
		<ng-container #modalContent></ng-container>
  `,
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent implements OnInit {
  @ViewChild('modalContent', { read: ViewContainerRef })
  modalContent: ViewContainerRef;

  constructor(
    private modalService: ModalService,
    @SkipSelf() private injector: Injector,
  ) {}

  ngOnInit() {
    this.modalService.setContainer(this.modalContent, this.injector);
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/ko/webapp/src/app/@shared/ui/modal/modal.component.ts